// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "pikaday" + "-" + "9765a7" + ".js";
};